/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Company_CompanyConfigurationDto } from '../models/Wealthlane_AwardService_Dtos_Company_CompanyConfigurationDto';
import type { Wealthlane_AwardService_Dtos_Company_UpdateCompanyConfigurationDto } from '../models/Wealthlane_AwardService_Dtos_Company_UpdateCompanyConfigurationDto';
import type { Wealthlane_AwardService_Dtos_Company_UpdateCompanyIntendedShareRegistrationDto } from '../models/Wealthlane_AwardService_Dtos_Company_UpdateCompanyIntendedShareRegistrationDto';
import type { Wealthlane_AwardService_Dtos_Company_UpdateCompanyPriceThresholdDto } from '../models/Wealthlane_AwardService_Dtos_Company_UpdateCompanyPriceThresholdDto';
import type { Wealthlane_AwardService_Dtos_Company_UpdateCompanyTransactionAcquisitionTypeDto } from '../models/Wealthlane_AwardService_Dtos_Company_UpdateCompanyTransactionAcquisitionTypeDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyService {

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiAwardApiAppCompanyIntendedShareRegistrationType(
requestBody?: Wealthlane_AwardService_Dtos_Company_UpdateCompanyIntendedShareRegistrationDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/company/intended-share-registration-type',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiAwardApiAppCompanyTransactionAcquisitionType(
requestBody?: Wealthlane_AwardService_Dtos_Company_UpdateCompanyTransactionAcquisitionTypeDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/company/transaction-acquisition-type',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiAwardApiAppCompanyPriceThreshold(
requestBody?: Wealthlane_AwardService_Dtos_Company_UpdateCompanyPriceThresholdDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/company/price-threshold',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Company_CompanyConfigurationDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCompanyCompanyConfiguration(): CancelablePromise<Wealthlane_AwardService_Dtos_Company_CompanyConfigurationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/company/company-configuration',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiAwardApiAppCompanyCompanyConfiguration(
requestBody?: Wealthlane_AwardService_Dtos_Company_UpdateCompanyConfigurationDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/company/company-configuration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
